import { IGroupConfigurationData, IPharmacyORE } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { ISaveInstruction } from "global/Application/dataActions";


export class RevisionResetTransformer extends BaseJsonTransformer {
    readonly instructions?: ISaveInstruction;

    constructor(instructions?: ISaveInstruction) {
        super();
        this.instructions = instructions;
    }

    async after(json: IGroupConfigurationData): Promise<void> {

        // for scenarios where we are creating new from UI, properties screen will override revision information
        // there is reset for create new
        if (this.instructions?.onSaveClone)
            return;

        json.isRevision = {
            type: 'bool',
            value: false,
        };

        json.revisionTasks = [];

    }
}
